import React from 'react';
import {Button, Row} from 'reactstrap';
import {Panel} from "primereact/panel";
import DataTable from "../../shared/component/dataTable/DataTable";
import TtRegionColumn from "../../shared/component/dataTable/columns/TtRegionColumn.json"
import Toolbar from "../../shared/component/toolbar/Toolbar";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Translate from "../../shared/language/Translate";
import Dialog from "../../shared/component/dialog/Dialog";
import Service from "../../shared/service/Service";
import {PAGE_MODE} from "../../shared/utils/Constants";
import TtRegionSave from "./TtRegionSave";
import {AvForm} from "availity-reactstrap-validation";



class TtRegion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageMode: null
        };
        this.service = new Service('ttRegion');
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Panel header="TT Bölge Tanımları" style={{width: '75%'}}>
                    <Toolbar display={true}>
                        <div className="p-toolbar-group-right">
                            <Button color="primary" onClick={this.addNew}>
                                <Translate contentKey="entity.action.add">Yeni Kayıt</Translate>
                            </Button>
                        </div>
                    </Toolbar>

                    <DataTable ref={(elem) => this.refDataTable = elem} fields={TtRegionColumn.fields} dataURL="ttRegion/findAll"
                               privilege="allow"
                               selectionMode="single" onDataSelect={this.onDataSelect} export={true}/>

                    <Dialog visible={this.state.displayDialog}
                            header={GeneralUtils.getDialogHeader('TT Bölge', this.state.pageMode)}
                            onHide={() => this.setState({displayDialog: false})} style={{width: '50%'}}>
                        <AvForm onValidSubmit={this.save}>
                            <Toolbar
                                display={true}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" type="submit" className="float-right">
                                        <Translate contentKey="entity.action.save">Kaydet</Translate>
                                    </Button>
                                    <Button color="primary" className="float-right"
                                            onClick={() => this.setState({displayDialog: false})}>
                                        <Translate contentKey="entity.action.save">Vazgeç</Translate>
                                    </Button></div>

                            </Toolbar>
                            <TtRegionSave ref={elem => this.refTtRegionSave = elem}/>
                        </AvForm>
                    </Dialog>
                </Panel>
            </Row>
        );
    }

    refresh = () => {
        this.refDataTable.refresh();
    }

    addNew = () => {
        this.setState({displayDialog: true, pageMode: PAGE_MODE.CREATE});
        this.refTtRegionSave.clearData();
    }

    onDataSelect = (data) => {
        let pageMode = GeneralUtils.getPageModeFromPrivilege(TtRegionColumn.name);
        this.setState({displayDialog: true, pageMode: pageMode});
        this.refTtRegionSave.clearData();
        this.refTtRegionSave.setData(Object.assign({}, data), pageMode);
    }

    save = () => {
        let ttRegion = this.refTtRegionSave.getData();
        if (!GeneralUtils.isNullOrEmpty(ttRegion.id)) {
            this.service.update(ttRegion).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({displayDialog: false});
                    this.refresh();
                }
            });
        } else {
            this.service.create(ttRegion).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({displayDialog: false});
                    this.refresh();
                }
            });
        }
    }
}


export default TtRegion;
